module.exports = __webpack_public_path__ + "img/phone.d65c3174.svg";